<template>
   <div class="bg-light pt-3 pt-lg-5 pb-5">
      <b-container fluid>
         <b-row>
            <b-col cols="12" lg="3" xl="2" class="p-0">
               <DashUserNav></DashUserNav>
            </b-col>
            <b-col cols="12" lg="9" xl="10" class="pl-3 pl-lg-3 mt-3">
               <div v-if="userId">
                  <Extract :customerId="userId"></Extract>
               </div>
            </b-col>
         </b-row>
      </b-container>
   </div>


</template>

<script>

import DashUserNav from "../../../../components/DashUserNav";
import Extract from "@/views/dashboard/owner-panel/Extract";

export default {
   name: 'MyExtract',
   components: {
      DashUserNav,
      Extract
   },
   data() {
      return {
         userId: ''
      }
   },
   mounted() {
      if (this.currentUser) {
         this.userId = this.currentUser.user._id
      }
   },
   computed: {
      currentUser() {
         return this.$store.state.auth.user;
      },
   }
};
</script>

<style lang="scss">

</style>
